/**
 * 
 * @param {String} outputDivID 
 * @param {String} outputjsons
 */

export function printPrettyJson(jsons = '{}', outputDivID = 'jsonPreview'){

  const outputPretty =  (jsonstring) => {
    // prettify spacing
    var pretty  = JSON.stringify(JSON.parse(jsonstring), null, 2);
    // syntaxhighlight the pretty print version
    var shpretty = syntaxHighlight(pretty);
    // create the element, to a pre element
    let preElm = document.getElementById("pre-json")
    
    if (!preElm) {
      preElm = document.createElement("pre");
      preElm.id = "pre-json"
    }
    preElm.innerHTML = shpretty;

    // select target where the json to be hightlight
    const preCodeWrapper = document.getElementById(outputDivID)
    // clear all child
    preCodeWrapper.childNodes.forEach(oldChild => {
      preCodeWrapper.removeChild(oldChild)
    })
    // append pre to the wrapper
    preCodeWrapper.appendChild(preElm)
  }

  const syntaxHighlight = (json) => {
        
    if (typeof json != 'string') {
        json = JSON.stringify(json, undefined, 2);
    }
    
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'key';
            } else {
              cls = 'string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
  }

  outputPretty(jsons)
}